import Vue from 'vue'
import Router from 'vue-router'
import routes from './router'
Vue.use(Router)
const router = new Router({
    mode: 'history',
  	routes
})
router.beforeEach((to,from,next) => {
    const token = localStorage.getItem('token');
    if(!token && to.path != '/login'){//未登录，强制登录
        next({
            name:"login"  // 将跳转的路由path作为参数，登录成功后跳转到该路由
        });
    }else{
        next();
    }
});

// router.beforeEach((to, from, next) => {
//   	if (to.matched.some(record => record.meta.requireAuth)) { // 判断该路由是否需要登录权限
//     	if (localStorage.getItem('token') || localStorage.getItem('userId') || localStorage.getItem('nickname') || localStorage.getItem('sysRoleId')) { // 判断缓存里面是否有 token  //在登录的时候设置它的值
//         	next();
//     	} else {
//         	next({
//             	path: '/login',
//             	query: {
//                 	redirect: to.fullPath
//             	}
//         	})
//     	}
// 	} else {
//     	next();
// 	}
// });
// router.afterEach(to => {
//   window.scrollTo(0, 0)
// })
export default router



// WEBPACK FOOTER //
// ./src/router/index.js